import { extend } from 'flarum/common/extend';

import ItemList from 'flarum/common/utils/ItemList';
import app from 'flarum/forum/app';

import type Mithril from 'mithril';

export default function addIntroToAboutPage() {
  const {
    pages: { VirtualAuthorsList },
  } = require('@davwheat-virtual-authors');

  extend(VirtualAuthorsList.prototype, 'viewItems', function (items: ItemList<Mithril.Children>) {
    items.add('intro', <aside class="container Bhasvic-AuthorsAboutIntro">{m.trust(app.forum.attribute('bhasvic-theme.aboutUsText'))}</aside>, 90);
  });
}
